import { get } from 'lodash';

import Banner from '@zenbusiness/zui/Banner';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Card from '@zenbusiness/zui/Card';
import Stack from '@zenbusiness/zui/Stack';
import { styled, superstyled } from '@zenbusiness/zui/styles';
import Tab from '@zenbusiness/zui/Tab';
import Tabs from '@zenbusiness/zui/Tabs';
import Text from '@zenbusiness/zui/Text';

export const BuyBoxWrapper = superstyled({
  name: 'ZuiBuyBoxWrapper',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({

    [theme.breakpoints.up('lg')]: {
      position: 'relative',
      zIndex: 1
    }
  })
});

export const BuyBoxContainer = superstyled({
  name: 'ZuiBuyBoxContainer',
  slot: 'Root',
  tag: Stack,
  styles: ({ theme }) => ({
    gap: theme.spacing(2),

    [theme.breakpoints.up('lg')]: {
      position: 'absolute',
      top: theme.spacing(3),
      width: '100%'
    }
  })
});

export const TabsContainer = superstyled({
  name: 'ZuiTabsContainer',
  slot: 'Root',
  tag: Tabs,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.grey.dark,
    borderRadius: theme.shape.rounded.lg,
    alignItems: 'center',
    height: '4rem',

    '& .MuiTabs-flexContainer': {
      width: '100%',
      gap: 0
    },

    '& .MuiTabs-indicator': {
      display: 'none'
    }
  })
});

export const TabButton = superstyled({
  name: 'ZuiTabButton',
  slot: 'Root',
  tag: Tab,
  styles: ({ theme, selected }) => ({
    flex: 1,
    maxWidth: 'unset',
    height: '4rem',
    padding: 0,
    borderRadius: theme.shape.rounded.lg,
    backgroundColor: selected ? theme.palette.primary.main : theme.palette.background.grey.dark
  })
});

export const BuyBox = superstyled({
  name: 'ZuiBuyBox',
  slot: 'Root',
  tag: Card,
  propsAdded: {
    color: 'paper'
  },
  styles: ({ theme, note, color }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: 0,
    backgroundColor: color ? get(theme, color) : 'transparent',
    borderColor: note ? 'transparent' : theme.palette.background.grey.dark
  })
});

export const BuyBoxContent = superstyled({
  name: 'ZuiBuyBoxContent',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.grey.light,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    boxShadow: theme.shadows[3],
    padding: theme.spacing(1.5),

    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(2)
    }
  })
});

export const ButtonLinkContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',

  [theme.breakpoints.up('lg')]: {
    alignItems: 'end'
  }
}));

export const ButtonLink = styled(Button)(() => ({
  width: 'fit-content',

  '&:hover, &:focus': {
    backgroundColor: 'transparent'
  },

  '& span': {
    margin: 0
  }
}));

export const PriceContainer = superstyled({
  name: 'ZuiBuyBoxPriceContainer',
  slot: 'Root',
  tag: Stack,
  styles: ({ theme }) => ({
    alignItems: 'end',
    gap: theme.spacing(0.5)
  })
});

export const BuyBoxText = superstyled({
  name: 'ZuiSubheader',
  slot: 'Root',
  tag: Text,
  propsAdded: {
    size: 'lg'
  }
});

export const FeeText = superstyled({
  name: 'ZuiBuyBoxFee',
  slot: 'Root',
  tag: Text,
  propsAdded: {
    size: 'xs',
    color: 'tertiary',
    textAlign: 'right'
  },
  styles: ({ theme }) => ({
    display: 'none',

    [theme.breakpoints.up('lg')]: {
      display: 'block'
    }
  })
});

export const StyledCouponBanner = styled(Banner)(({ theme }) => ({
  backgroundColor: theme.palette.background.green.light,
  color: theme.palette.text.primary,

  '& .MuiStack-root': {
    gap: '0 !important'
  }
}));

export const StrikethroughPrice = superstyled({
  name: 'ZuiBuyBoxStrikethroughPrice',
  slot: 'Root',
  tag: Text,
  propsAdded: {
    size: 'sm',
    color: 'primary'
  },
  styles: () => ({
    textDecoration: 'line-through'
  })
});

export const DiscountPriceContainer = superstyled({
  name: 'ZuiBuyBoxDiscountPriceContainer',
  slot: 'Root',
  tag: Stack,
  styles: ({ theme }) => ({
    alignItems: 'flex-end',
    gap: theme.spacing(0),

    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start'
    }
  })
});

export const FeatureItem = superstyled({
  name: 'ZuiFeatureItem',
  slot: 'Root',
  tag: Stack,
  styles: ({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),

    [theme.breakpoints.up('lg')]: {
      width: '100%'
    }
  })
});

export const SmallCopyText = superstyled({
  name: 'ZuiSmallCopyText',
  slot: 'Root',
  tag: Text,
  propsAdded: {
    color: 'tertiary',
    size: 'sm'
  }
});
